module.exports = __webpack_public_path__ + "static/img/headerLogo.c7b6f9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/headerLogo.svg
// module id = e8WG
// module chunks = 6